module.exports = __webpack_public_path__ + "static/media/ni.c90e4163.svg";